/**
 * Drains the toast store into the Fluent Toaster. Mounted once near the app root.
 */
import { useEffect, useRef } from 'react';
import {
  Toaster,
  useToastController,
  useId,
  Toast,
  ToastTitle,
  ToastBody,
} from '@fluentui/react-components';
import { useToastStore } from '../state/toast';

export function ToastHost() {
  const toasterId = useId('mmap-toaster');
  const { dispatchToast } = useToastController(toasterId);
  const toasts = useToastStore((s) => s.toasts);
  const remove = useToastStore((s) => s.remove);
  const dispatched = useRef<Set<number>>(new Set());

  useEffect(() => {
    for (const t of toasts) {
      if (dispatched.current.has(t.id)) continue;
      dispatched.current.add(t.id);
      dispatchToast(
        <Toast>
          <ToastTitle>{t.title}</ToastTitle>
          {t.body ? <ToastBody>{t.body}</ToastBody> : null}
        </Toast>,
        { intent: t.intent, timeout: 6000 },
      );
      remove(t.id);
    }
  }, [toasts, dispatchToast, remove]);

  return <Toaster toasterId={toasterId} />;
}

export default ToastHost;
